import React from 'react';
import { ComponentRenderer } from './ComponentRenderer';
import type { Component } from '../schemas/validation';

interface ComponentListProps {
  components: Component[];
  websiteContext?: {
    subdomain: string;
    website: any;
    isPublicView: boolean;
  };
}

export const ComponentList: React.FC<ComponentListProps> = ({
  components,
}) => {
  // Sort components by order
  const sortedComponents = [...components].sort((a, b) => a.order - b.order);

  // Log head-content components for debugging
  const headContentComponents = sortedComponents.filter(c => c.type === 'head-content');
  if (headContentComponents.length > 0) {
    console.log('🔍 ComponentList: Found head-content components:', headContentComponents);
  }

  return (
    <div className="component-list">
      {sortedComponents.map((component) => (
        <ComponentRenderer
          key={component.id}
          component={component}
          isEditing={false}
        />
      ))}
    </div>
  );
}; 